"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var core_1 = require("@material-ui/core");
var CloseIcon_1 = __importDefault(require("../../app/components/widgets/CloseIcon"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        closeButton: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
    });
});
// TODO: refactor other components to use this CloseButton
function CloseButton(_a) {
    var onClick = _a.onClick;
    var classes = useStyles();
    return (react_1.default.createElement(IconButton_1.default, { onClick: onClick, className: classes.closeButton },
        react_1.default.createElement(CloseIcon_1.default, { size: 24 })));
}
exports.default = CloseButton;
